/**
 * ContactFormHeader — the heading block above the marketing contact form.
 *
 * Extracted from `<ContactPage>` to cut the page's JSX nesting depth
 * (`web/render-method-complexity`): the page's deepest branch ran
 * section → div.container → div.contact-grid → div → div.contact-form-header
 * → h1. Rendering the same wrapper + heading + subtitle here keeps the DOM
 * byte-identical (same classNames, same `id="contact-title"` target for the
 * page's `aria-labelledby`) while dropping the page to depth 5.
 *
 * @module portals/marketing-website/components/ContactFormHeader
 */

import PropTypes from 'prop-types';

/**
 * @param {Object} props
 * @param {string} props.title - Translated form title.
 * @param {string} props.subtitle - Translated form subtitle.
 * @returns {React.JSX.Element}
 */
export default function ContactFormHeader({ title, subtitle }) {
  return (
    <div className="contact-form-header">
      <h1 id="contact-title" className="contact-form-title">
        {title}
      </h1>
      <p className="contact-form-subtitle">{subtitle}</p>
    </div>
  );
}

ContactFormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};
